import { render } from "./EditProfilePopup.vue?vue&type=template&id=4014575a&scoped=true"
import script from "./EditProfilePopup.vue?vue&type=script&lang=js"
export * from "./EditProfilePopup.vue?vue&type=script&lang=js"

import "./EditProfilePopup.vue?vue&type=style&index=0&id=4014575a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4014575a"]])

export default __exports__